import {useEffect, useState} from 'react';
import useFloatingSize from '@/components/soopi/hooks/useFloatingSize';
import usePreventScrollOnDrag from '@/components/soopi/hooks/usePreventScrollOnDrag';

const useSoopiAnimation = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [isLeft, setIsLeft] = useState(false);
  const [position, setPosition] = useState({
    x: window.innerWidth,
    y: -100,
  });

  usePreventScrollOnDrag(isDragging);
  const {value} = useFloatingSize();

  const handleDragStart = (event) => {
    setIsDragging(true);
    event.preventDefault();
  };

  const calculateSnappedPosition = (info = null) => {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    // 현재 드래그 위치 계산
    const finalX = info?.point?.x || position.x; // `info`가 없을 경우 현재 위치 사용

    const finalY = info ? position.y + info.offset.y : position.y;
    // 화면 55%를 기준으로 좌우 판단
    const isRight = info ? finalX > viewportWidth * 0.55 : !isLeft;

    // 좌우 스냅
    const snappedX = !isRight ? -1 * (viewportWidth - value * 1.3) : -30;

    // Y 값 제한
    const minY = -100; // 최소 Y 좌표
    const maxY = -1 * viewportHeight + value * 1.3; // 최대 Y 좌표 (화면 높이 - 30px)
    const snappedY = Math.min(minY, Math.max(finalY, maxY)); // 범위 제한 적용

    return {x: snappedX, y: snappedY, isRight};
  };

  const handleDragEnd = (_test, info = null) => {
    setIsDragging(false);

    const {x, y, isRight} = calculateSnappedPosition(info);
    setIsLeft(!isRight);
    // 상태 업데이트
    setPosition({x: x + 0.01, y: y + 0.01}); // x를 약간 변경하여 애니메이션 트리거

    // x 값을 다시 정확한 snappedX로 업데이트
    setTimeout(() => {
      setPosition({x, y});
    }, 100);

    document.body.style.WebkitUserSelect = '';
  };

  useEffect(() => {
    //플로팅 사이즈 최초 변경시 위치 계산
    if (value) {
      const {x, y} = calculateSnappedPosition();
      setPosition({x, y});
    }
  }, [value]);

  useEffect(() => {
    const updateConstraintsAndPosition = () => {
      const {x, y} = calculateSnappedPosition(null);
      setPosition({x, y});
    };

    updateConstraintsAndPosition();
    window.addEventListener('resize', updateConstraintsAndPosition);

    return () => {
      window.removeEventListener('resize', updateConstraintsAndPosition);
    };
  }, []);

  return {
    isLeft,
    isDragging,
    handleDragStart,
    handleDragEnd,
    position,
  };
};

export default useSoopiAnimation;
